import { Sort } from './sort';
/**
 * Sort domain of x scale of mark groups by groups.
 */
export var SortY = function SortY() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return Sort(Object.assign(Object.assign({}, options), {
    channel: 'y'
  }));
};
SortY.props = {};